export const ID15 = () => {
    return (
        <div>
            <h2 className="servicePage_title">1С:АГЕНТ ПЛЮС</h2>
            <div className="content" readonly="">
                <div>
                    <h2>«Агент Плюс. 2.0»</h2>
                    <div>
                        Комплекс решений для создания собственных приложений для выездных сотрудников разных отраслей и
                        модификации приложения «Агент Плюс: Мобильная торговля»
                    </div>

                    <div>
                        Комплекс решений для создания собственных приложений для выездных сотрудников разных отраслей и
                        модификации приложения «Агент Плюс: Мобильная торговля»
                    </div>
                    <div>Чтобы создать или модифицировать приложение, не нужно привлекать сторонние компании, с этим
                        справятся штатные 1С-специалисты.
                    </div>
                </div>

                <div>
                    <h3>Из чего состоит платформа</h3>
                    <h4>«Конфигуратор»</h4>
                    <div>Среда разработки для программирования на языке L9. Предоставляется БЕСПЛАТНО</div>

                    <h4>Исполняющая машина языка L9</h4>
                    <div>Cодержит в себе необходимый набор инструментов для запуска конфигурации на мобильном
                        устройстве. Предоставляется БЕСПЛАТНО
                    </div>

                    <h4>Технологическая конфигурация</h4>
                    <div>Лицензия, которая приобретается на каждого выездного сотрудника.</div>
                </div>

                <div>
                    <h3>как работать с платформой</h3>

                    <ul>
                        <li>Скачать и установить Конфигуратор.</li>
                        <li>Ознакомиться с руководством по разработке.</li>
                        <li>Открыть существующую конфигурацию или создать собственную конфигурацию. Этот шаг занимает
                            99% времени работы над приложением.
                        </li>
                        <li>Выполнить сборку конфигурации с использованием исполняющей машины.</li>
                        <li>Загрузить полученный файл и установить его на мобильное устройство.</li>
                        <li>Ввести код от лицензии «Агент Плюс: Технологическая конфигурация».</li>
                    </ul>
                </div>

                <div>
                    <h3>Мобильные бизнес-приложения, разработанные на платформе «Агент Плюс. 2.0»</h3>

                    <div>
                        <h4>Приложение для водителей</h4>
                        <div>
                            Мобильное решение для автоматизации водителей-экспедиторов. Это приложение подойдет
                            производителям различных товаров, торговых и логистических
                            компаний. Позволит ставить задачи водителям-экспедиторам, планировать посещения клиентов и
                            контролировать передвижения сотрудников.
                        </div>
                    </div>
                    <div>
                        <h4>Программа "Логистика развоза"</h4>
                        <div>
                            Решение, которое позволяет автоматически распределять все имеющиеся заказы на развоз таким
                            образом, чтобы: — максимально загрузить весь текущий
                            транспорт; — выдержать жёсткие сроки доставки; — построить для каждой машины на электронной
                            карте оптимальный маршрут проезда с учетом дорожной
                            обстановки и минимизации пробега или времени развоза.
                        </div>
                    </div>
                </div>

                <div>
                    <h2>Мобильная торговля 3.0</h2>
                    <div>Мобильное приложение, которое позволяет торговым агентам быстро оформлять заказы на поставку
                        товаров без необходимости посещать офис
                    </div>

                    <div>
                        <h3>Преимущества:</h3>
                        <ul>
                            <li>Простая установка из Google Play и быстрые обновления для всех агентов</li>
                            <li>Совместимость с ОС Android и iOS (поддержка iOS сейчас в разработке)</li>
                            <li>Базовый функционал заказов</li>
                            <li>Обмен с учетной системой по протоколу WebDAV</li>
                        </ul>
                    </div>
                </div>

                <div>
                    <h3>ОТЛИЧИТЕЛЬНЫЕ ВОЗМОЖНОСТИ ПРИЛОЖЕНИЯ МОБИЛЬНОЙ ТОРГОВЛИ 3.0</h3>

                    <ul>
                        <li>Быстродействие и оптимальные требования к ресурсам устройства</li>
                        <li>Быстрый поиск по контрагентам и торговым точкам</li>
                        <li>Созданное с нуля приложение и новая технологическая платформа</li>
                        <li>
                            Готовое рабочее место Супервайзера для iOS, Android, Windows, Linux — мониторинг действий и
                            передвижений сотрудников с использованием Онлайн-карт
                        </li>
                        <li>
                            <strong>Новое лицензирование — авторизация по мобильному номеру телефона
                                сотрудников</strong>
                            <ul>
                                <li>Технология хорошо себя зарекомендовала в приложении «Точки»</li>
                                <li>
                                    Не нужно покупать какое-либо количество рабочих мест — просто в новом «Личном
                                    кабинете» добавляете нужных сотрудников и пополняете баланс
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>

                <div>
                    <h3>Что вы получаете, установив приложение “Агент Плюс: Мобильная торговля 3.0”</h3>
                    <div>Одновременное получение данных без задержек:</div>
                    <ul>
                        <li>Повышение скорости создания заказов на поставку товаров в торговые точки;</li>
                        <li>Минимизация ошибок при оформлении заказов;</li>
                        <li>Меньшее количество торговых агентов выполняет больше работы - это отличная экономия
                            средств.
                        </li>
                    </ul>
                </div>

                <div>
                    <h2>Управление дистрибуцией</h2>
                    <div>Полный набор инструментов для контроля продаж и работы торговых представителей</div>
                </div>

                <div>
                    <h3>Преимущества:</h3>
                    <ul>
                        <li>Лёгкая настройка c внедрением в один клик</li>
                        <li>Возможность дополнять или изменять функционал продукта с помощью штатных 1С-специалистов
                        </li>
                        <li>Обновления продукта без дополнительных оплат</li>
                    </ul>
                </div>

                <div>
                    <h3>С помощью программного решения вы сможете</h3>
                    <ul>
                        <li>Построить эффективную мотивацию для торгового отдела</li>
                        <li>Определить, насколько хорошо работают команды торговых агентов</li>
                        <li>Подключить всех дистрибьюторов к единой системе.</li>
                    </ul>
                </div>

                <div>
                    <h3>Возможности продукта</h3>

                    <ul>
                        <li>Работа по маршруту и создание заказа через посещение точки в маршруте</li>
                        <li>Гибкая настройка монитора показателей для каждого пользователя</li>
                        <li>Контролируйте, отгружаются ли заявки в срок и в полном объеме</li>
                        <li>Фотоотчеты торговых агентов - удобный способ управлять ситуацией на полке прямо из офиса
                        </li>
                    </ul>
                </div>

                <div>
                    <h3>Основной функционал</h3>
                    <ul>
                        <li>Сбор данных о вторичных продажах.</li>
                        <li>Карта дистрибуции - визуализируйте территорию продаж и выделяйте лидеров по
                            бизнес-регионам.
                        </li>
                        <li>Гибкая настройка монитора показателей для каждого пользователя</li>
                        <li>Контроль передвижений торговых агентов по GPS. Узнайте, был ли совершен визит?</li>
                        <li>Планирование продаж и прогноз выполнения. Узнайте, успеете ли Вы выполнить план продаж,
                            продавая такими темпами?
                        </li>
                        <li>Фотоотчеты торговых агентов - удобный способ управлять ситуацией на полке прямо из офиса
                        </li>
                    </ul>
                </div>

                <div>
                    <h3>Вам подойдет этот продукт, если вы:</h3>
                    <ul>
                        <li>Производитель или дистрибьютор с торговыми агентами в штате или без них</li>
                        <li>Компания или BTL-агентство, которые заинтересованы в сборе данных работы мерчендайзеров</li>
                    </ul>
                </div>
            </div>
        </div>
    )
}